import settings from "@settings";

export const weekDayContainer = {
  minWidth: "300px",
};

export const weekDayContainerInvisible = {
  minWidth: "300px",
  opacity: 0,
};

export const trainingImage = {
  width: "100%",
  height: "180px",
  backgroundColor: settings.colors.lightgrey,
  overflow: "hidden",
  // borderRadius: `${settings.siz.medium}`,
};

export const trainingElement = settings.mq({
  position: "relative",
  height: "auto",
  overflow: "hidden",
  width: ["100%", "49%", "49%", "32%"],
  display: "flex",
  backgroundColor: settings.colors.light,
  borderRadius: settings.sizes.medium,
  // boxShadow: settings.shadows.regular,
  // borderTop: `5px solid ${ settings.colors.primary}` ,
  alignItems: "stretch",
  flexDirection: "column",
  justifyContent: "space-between",
  gap: settings.sizes.medium,
  marginBottom: settings.sizes.extraLarge,
});

export const calendarContent = settings.mq({
  display: "flex",
  flexDirection: ["column", "column", "column"],
  alignItems: ["flex-start", "flex-start", "flex-start"],
  justifyContent: "space-between",
  gap: settings.sizes.medium,
});

export const trainingElementuttonContainer = settings.mq({
  marginBottom: settings.sizes.small,
  justifySelf: "flex-end",
  width: "100%",
  padding: settings.padding.small,
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
});

export const weekdayElement = {
  width: "100%",
  backgroundColor: settings.colors.primary,
  color: settings.colors.light,
  padding: settings.padding.medium,
  marginBottom: settings.sizes.medium,
  marginTop: settings.sizes.medium,
  boxShadow: settings.shadows.regular,
};

export const calendarContainer = {
  width: "100%",
  minHeight: "40vh",
  overflow: "auto",
  h3: { fontWeight: "bold", marginBottom: 0 },
};
